import React, { useCallback, useEffect, useRef, useState } from 'react';


const DEFAULT_CONTEXT = {
  keys: {}
};


const KeyboardContext = React.createContext(DEFAULT_CONTEXT);

const KeyboardProvider = ({ children }) => {
  const keysRef = useRef({});

  useEffect(() => {
    const onKeyDown = (evt) => {
      const key = evt.key.toLowerCase();
      keysRef.current[key] = true;
    };
    const onKeyUp = (evt) => {
      const key = evt.key.toLowerCase();
      keysRef.current[key] = false;
    };

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
    }
  }, []);

  return (
    <KeyboardContext.Provider value={keysRef.current}>
      { children }
    </KeyboardContext.Provider>
  );
};


export {
  KeyboardContext,
  KeyboardProvider,
};
